// extracted by mini-css-extract-plugin
export var button = "_jj-0";
export var donut = "_jj-1";
export var donutFill = "_jj-3";
export var donutTrack = "_jj-2";